import { cx } from '@emotion/css';
import { useInViewport } from 'ahooks';
import { useContext, useRef } from 'react';
import { DialogueModeContext } from 'views/Conversation/Chat/components/DialogueModeContext.tsx';

export interface StickerMessageProps {
  className?: string;
  src: string;
  lazyScrollContainer?: Element | null;
}

const StickerMessage = (props: StickerMessageProps) => {
  const { src, className, lazyScrollContainer } = props;

  const ref = useRef<HTMLDivElement>(null);
  const [inViewPort] = useInViewport(ref, {
    root: lazyScrollContainer,
  });

  const isFaq = useContext(DialogueModeContext) === 'faq';

  return (
    <div ref={ref} className={cx('w-[160px] h-[160px]', className)}>
      <img
        className="w-full h-full mix-blend-multiply"
        src={inViewPort || isFaq ? src : ''}
        alt="sticker"
      />
    </div>
  );
};
export default StickerMessage;
